/**
 * @description Encodes the candidate-search salary as a trailing "N eur" suffix on the keyword
 * slug, so a saved search like "manager" with salary=500 round-trips as "manager 500 eur".
 *
 * Lives outside the SidebarNavigationContext ('use client') so server components and SSR pages
 * can use the same encoding without crossing the client boundary.
 */

const EUR_SUFFIX_RE = /\s*(\d+)\s+eur\s*$/i;

/** Appends "N eur" to the keyword so salary travels in the path slug, not as a query param. */
export const buildKeywordWithSalary = (keyword: string | undefined, salary: number | undefined): string | undefined => {
  if (!salary) return keyword;
  return keyword ? `${keyword} ${salary} eur` : `${salary} eur`;
};

/** Strips a trailing "N eur" off a keyword, returning the bare keyword and the parsed salary. */
export const extractSalaryFromKeyword = (raw: string | undefined): { keyword?: string; salary?: number } => {
  if (!raw) return {};
  const match = raw.match(EUR_SUFFIX_RE);
  if (!match) return { keyword: raw };
  const stripped = raw.slice(0, match.index).trim();
  return {
    ...(stripped && { keyword: stripped }),
    salary: Number(match[1]),
  };
};
